// LocalStorage-backed registry for agency and physician profiles.
// Device-bound only; never sent to the backend until the RN explicitly
// applies a profile into the wizard payload.

const AGENCY_KEY = "wi-pa-saved-agencies-v1";
const PHYS_KEY   = "wi-pa-saved-physicians-v1";

function safeRead(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}
function safeWrite(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* localStorage unavailable or full — non-fatal */
  }
}

const AGENCY_FIELDS = ["name","provider_number","npi","address","phone","fax","contact_name"];
const PHYS_FIELDS   = ["name","npi","address","phone","fax"];

function profileId() {
  return `p_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,7)}`;
}

function pick(obj, keys) {
  const out = {};
  keys.forEach((k) => { out[k] = obj?.[k] ?? ""; });
  return out;
}

export function listAgencies() { return safeRead(AGENCY_KEY); }
export function listPhysicians() { return safeRead(PHYS_KEY); }

export function saveAgency(current) {
  const data = pick(current, AGENCY_FIELDS);
  if (!data.name.trim()) return { ok: false, error: "Agency name is required to save." };
  const all = listAgencies();
  // Overwrite by name if already present (avoid duplicates).
  const idx = all.findIndex((a) => a.name.trim().toLowerCase() === data.name.trim().toLowerCase());
  if (idx >= 0) {
    const updated = { ...all[idx], ...data };
    all[idx] = updated;
    safeWrite(AGENCY_KEY, all);
    return { ok: true, profile: updated, updated: true };
  }
  const profile = { id: profileId(), ...data };
  safeWrite(AGENCY_KEY, [profile, ...all]);
  return { ok: true, profile, updated: false };
}

export function savePhysician(current) {
  const data = pick(current, PHYS_FIELDS);
  if (!data.name.trim()) return { ok: false, error: "Physician name is required to save." };
  const all = listPhysicians();
  const idx = all.findIndex((a) => a.name.trim().toLowerCase() === data.name.trim().toLowerCase());
  if (idx >= 0) {
    const updated = { ...all[idx], ...data };
    all[idx] = updated;
    safeWrite(PHYS_KEY, all);
    return { ok: true, profile: updated, updated: true };
  }
  const profile = { id: profileId(), ...data };
  safeWrite(PHYS_KEY, [profile, ...all]);
  return { ok: true, profile, updated: false };
}

export function deleteAgency(id) {
  safeWrite(AGENCY_KEY, listAgencies().filter((a) => a.id !== id));
}
export function deletePhysician(id) {
  safeWrite(PHYS_KEY, listPhysicians().filter((a) => a.id !== id));
}
